import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createVNode as _createVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "new-trade-card"
}
const _hoisted_2 = { class: "new-trade-card-head" }
const _hoisted_3 = { class: "txtDv" }
const _hoisted_4 = { class: "secondDv" }
const _hoisted_5 = { class: "symbolTitle" }
const _hoisted_6 = { class: "profitDv" }
const _hoisted_7 = ["innerHTML"]
const _hoisted_8 = { class: "new-trade-card-middle" }
const _hoisted_9 = { class: "position-container" }
const _hoisted_10 = {
  key: 0,
  style: {"color":"#ff3b3b","background":"rgba(255, 59, 59, 0.1)"}
}
const _hoisted_11 = { key: 1 }
const _hoisted_12 = { class: "new-trade-card-body" }
const _hoisted_13 = { class: "col" }
const _hoisted_14 = ["innerHTML"]
const _hoisted_15 = { class: "col" }
const _hoisted_16 = ["innerHTML"]
const _hoisted_17 = ["innerHTML"]
const _hoisted_18 = { class: "col" }
const _hoisted_19 = ["innerHTML"]
const _hoisted_20 = ["innerHTML"]
const _hoisted_21 = { class: "col" }
const _hoisted_22 = { class: "new-trade-card-footer" }
const _hoisted_23 = { class: "user-container" }
const _hoisted_24 = { class: "order-container" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_StockImageTag = _resolveComponent("StockImageTag")!
  const _component_IconComponent = _resolveComponent("IconComponent")!
  const _component_ProfileAvatarComponent = _resolveComponent("ProfileAvatarComponent")!

  return (_ctx.trade && _ctx.stock)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _cache[6] || (_cache[6] = _createElementVNode("span", {
          class: "card--tag",
          style: {"background":"#ff895a","color":"white"}
        }, "Trade (Order)", -1)),
        _createElementVNode("div", _hoisted_2, [
          (!_ctx.tradeChanging)
            ? (_openBlock(), _createBlock(_component_StockImageTag, {
                key: 0,
                stockId: _ctx.trade.stockId,
                symbol: _ctx.trade.symbol,
                market: _ctx.trade.stockType ? _ctx.trade.stockType : _ctx.extractedStockId,
                disableRouting: false,
                style: {"margin-top":"-6px"}
              }, null, 8, ["stockId", "symbol", "market"]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("h6", null, _toDisplayString(_ctx.trade.symbol ?? "-"), 1),
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("p", _hoisted_5, _toDisplayString(_ctx.stockName ?? _ctx.trade.name ?? "-"), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("p", {
              innerHTML: 
            _ctx.$filters.systemNumberConvention(_ctx.stock.price, true, false, 110)
          
            }, null, 8, _hoisted_7),
            (_ctx.stock && _ctx.stock.changesPercentage)
              ? (_openBlock(), _createElementBlock("h6", {
                  key: 0,
                  class: _normalizeClass({ downward: _ctx.stock.changesPercentage < 0 })
                }, [
                  _createVNode(_component_IconComponent, {
                    class: "priceIcon",
                    icon: "stock-pricing-up-icon.svg"
                  }),
                  _createTextVNode(" " + _toDisplayString(_ctx.$filters.systemNumberConvention(
              _ctx.stock.changesPercentage,
              false,
              false
            )) + "% ", 1)
                ], 2))
              : _createCommentVNode("", true)
          ])
        ]),
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("div", _hoisted_9, [
            _cache[0] || (_cache[0] = _createElementVNode("h5", null, "Order:", -1)),
            (_ctx.trade.side === 'sell')
              ? (_openBlock(), _createElementBlock("p", _hoisted_10, _toDisplayString(_ctx.trade.side), 1))
              : (_openBlock(), _createElementBlock("p", _hoisted_11, _toDisplayString(_ctx.trade.side), 1))
          ]),
          _cache[1] || (_cache[1] = _createElementVNode("div", { class: "type-container" }, [
            _createElementVNode("h5", null, "Type:"),
            _createElementVNode("p", null, "DayTrade")
          ], -1))
        ]),
        _createElementVNode("div", _hoisted_12, [
          _createElementVNode("div", _hoisted_13, [
            _cache[2] || (_cache[2] = _createElementVNode("h5", null, "Shares", -1)),
            _createElementVNode("h6", {
              innerHTML: 
            _ctx.$filters.systemNumberConvention(_ctx.tradeQuantity, false, false, 100)
          
            }, null, 8, _hoisted_14)
          ]),
          _createElementVNode("div", _hoisted_15, [
            _cache[3] || (_cache[3] = _createElementVNode("h5", null, "P/Price", -1)),
            (_ctx.trade.limit_price)
              ? (_openBlock(), _createElementBlock("h6", {
                  key: 0,
                  innerHTML: 
            _ctx.$filters.systemNumberConvention(_ctx.trade.limit_price, true, false, 100)
          
                }, null, 8, _hoisted_16))
              : (_openBlock(), _createElementBlock("h6", {
                  key: 1,
                  innerHTML: 
            _ctx.$filters.systemNumberConvention(_ctx.trade.entry_price ? _ctx.trade.entry_price : _ctx.trade.buyPrice, true, false, 100)
          
                }, null, 8, _hoisted_17))
          ]),
          _createElementVNode("div", _hoisted_18, [
            _cache[4] || (_cache[4] = _createElementVNode("h5", null, "Total", -1)),
            (_ctx.trade.limit_price)
              ? (_openBlock(), _createElementBlock("h6", {
                  key: 0,
                  innerHTML: 
            _ctx.$filters.systemNumberConvention(_ctx.trade.limit_price * _ctx.tradeQuantity, true, false, 100)
          
                }, null, 8, _hoisted_19))
              : (_openBlock(), _createElementBlock("h6", {
                  key: 1,
                  innerHTML: 
            _ctx.$filters.systemNumberConvention((_ctx.trade.entry_price ? _ctx.trade.entry_price : _ctx.trade.buyPrice) * _ctx.tradeQuantity, true, false, 100)
          
                }, null, 8, _hoisted_20))
          ]),
          _createElementVNode("div", _hoisted_21, [
            _cache[5] || (_cache[5] = _createElementVNode("h5", null, "Gain", -1)),
            _createElementVNode("h6", {
              class: _normalizeClass(["gainGreen", { negative: _ctx.overallGainPercent < 0 }])
            }, [
              _createVNode(_component_IconComponent, {
                class: "priceIcon",
                icon: "stock-pricing-up-icon.svg"
              }),
              _createTextVNode(" " + _toDisplayString(_ctx.$filters.systemNumberConvention(
                _ctx.overallGainPercent,
                false,
                true,
                100
                )) + "%", 1)
            ], 2)
          ])
        ]),
        _createElementVNode("div", _hoisted_22, [
          _createElementVNode("div", _hoisted_23, [
            (_ctx.postUser)
              ? (_openBlock(), _createBlock(_component_ProfileAvatarComponent, {
                  key: _ctx.postUser.profilePicture,
                  profileImage: _ctx.postUser.profilePicture,
                  border: true,
                  badges: false,
                  class: "small"
                }, null, 8, ["profileImage"]))
              : (_openBlock(), _createBlock(_component_ProfileAvatarComponent, {
                  key: _ctx.images.profilePicture,
                  profileImage: _ctx.images.profilePicture,
                  border: true,
                  badges: false,
                  class: "small"
                }, null, 8, ["profileImage"])),
            _createElementVNode("p", null, _toDisplayString(_ctx.postUser ? _ctx.postUser.fullName : _ctx.user.fullName), 1)
          ]),
          _createElementVNode("div", _hoisted_24, [
            _createVNode(_component_IconComponent, { icon: "icon-trade-orders.svg" }),
            _createElementVNode("p", null, _toDisplayString(_ctx.formattedOrderDate), 1)
          ])
        ])
      ]))
    : _createCommentVNode("", true)
}